import { IAnalyticsContext } from '@scentregroup/shared/analytics'

import { IStoreRetailerItem, isIStoreDirectoryStoreItem } from './types'

export function trackClickNationalStoreDirectoryItem(
  analytics: IAnalyticsContext,
  item: IStoreRetailerItem,
  isNationalStore: boolean
): React.MouseEventHandler<HTMLLinkElement> {
  const { trackEvent } = analytics
  if (isIStoreDirectoryStoreItem(item)) {
    return e => {
      const target = e.currentTarget
      trackEvent({
        type: 'legacy',
        data: {
          event: 'Store Selected',
          content_id: item.id,
          content_source: `contentful_${item.spaceId}`,
          content_type: 'Store',
          content_title: item.title,
          store_slug: item.slug,
          centre_slug: item.centreSlug,
          context: isNationalStore
            ? 'National Store Directory'
            : 'Centre Store Directory',
          link_url: target.href,
          ...(target.innerText ? { ['link_text']: target.innerText } : null),
        },
      })
    }
  } else {
    return e => {
      const target = e.currentTarget
      trackEvent({
        type: 'legacy',
        data: {
          event: 'Retailer Selected',
          content_id: item.id,
          content_source: `contentful_${item.spaceId}`,
          content_type: 'Retailer',
          content_title: item.title,
          retailer_slug: item.slug,
          context: isNationalStore
            ? 'National Store Directory'
            : 'Centre Store Directory',
          link_url: target.href,
          ...(target.innerText ? { ['link_text']: target.innerText } : null),
        },
      })
    }
  }
}
